import Component from './AddAndGoToCart'

export default Component
